konnyScript(function($){

    $('.notiTit').click(function(){
    	var notiBox = $(this).parents('.notiBox');
        if(notiBox.hasClass('on')){
        	notiBox.removeClass('on');
        }else{
        	notiBox.addClass('on');
        }
    });

    //set slide
    var setSlide01 = new Swiper('.eventCon #set_swiper_slide1',{
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: '3.58%',
        loop: true,
        speed: 3000,
        autoplay:{
            delay: 0,
        },
    });
    var setSlide02 = new Swiper('.eventCon #set_swiper_slide2',{
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: '4.17%',
        loop: true,
        speed: 3000,
        autoplay:{
            delay: 0,
        },
    });
    var setSlide03 = new Swiper('.eventCon #set_swiper_slide3',{
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: '2.38%',
        loop: true,
        speed: 3000,
        autoplay:{
            delay: 0,
        },
    });
    
    //GIF 슬라이드
    var gifSlide = new Swiper('.eventCon #gif_swiper_slide1',{
            slidesPerView:1,
            slidesPerGroup:1,
            centeredSlides:true,
            loop:true,
            effect:'fade',
            speed :2000,
            autoplay:{
                delay:0,
                disableOnInteraction: false,
            },
    });
    var gifSlide = new Swiper('.eventCon #gif_swiper_slide2',{
            slidesPerView:1,
            slidesPerGroup:1,
            centeredSlides:true,
            loop:true,
            effect:'fade',
            speed :2000,
            autoplay:{
                delay:0,
                disableOnInteraction: false,
            },
    });
    
    //new slide
    var newSlide = new Swiper('.eventCon #con_swiper_slide1',{
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: '2.38%',
        //loop: true,
        scrollbar: {
            el: '.eventCon #con_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '.eventCon #con_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '.eventCon #con_swiper_slide1 .swiper-button-next',
            prevEl: '.eventCon #con_swiper_slide1 .swiper-button-prev',
        },
    });
    var newSlide = new Swiper('.eventCon #con_swiper_slide2',{
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: '2.38%',
        //loop: true,
        scrollbar: {
            el: '.eventCon #con_swiper_slide2 .swiper-scrollbar',
        },
        pagination: {
            el: '.eventCon #con_swiper_slide2 .swiper-pagination',
        },
        navigation: {
            nextEl: '.eventCon #con_swiper_slide2 .swiper-button-next',
            prevEl: '.eventCon #con_swiper_slide2 .swiper-button-prev',
        },
    });
    var newSlide = new Swiper('.eventCon #con_swiper_slide3',{
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: '2.38%',
        //loop: true,
        scrollbar: {
            el: '.eventCon #con_swiper_slide3 .swiper-scrollbar',
        },
        pagination: {
            el: '.eventCon #con_swiper_slide3 .swiper-pagination',
        },
        navigation: {
            nextEl: '.eventCon #con_swiper_slide3 .swiper-button-next',
            prevEl: '.eventCon #con_swiper_slide3 .swiper-button-prev',
        },
    });
});